module.exports = "/lucky-balls/img/drum/drum_loop_014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_014.png
// module id = 1029
// module chunks = 0